<div class="card">
    <div class="card-header">
      <h4>Customer Remittance Report</h4>
    </div>
    <div class="card-body m-0">
      <div class="row mb-2">
        <div class="col-xl-12">

              <div class="row g-9 mb-8">
                <!-- Customer Information (Mobile, ID, and Name) -->
                <div class="row mt-4">
                    <div class="col-md-4">
                        <label class="col-form-label" for="txnId">Transaction ID</label>
                        <input type="text" class="form-control" id="txnId" placeholder="Please enter Transaction ID"
                            [(ngModel)]="txnId" maxlength="50" (keypress)="OnlyNumbersAllowed($event)" />
                    </div>
                    <div class="col-md-4">
                        <label class="col-form-label" for="customerPhone">Customer Phone</label>
                        <input type="text" class="form-control" id="customerPhone"
                            placeholder="Please enter Customer Phone" [(ngModel)]="customerMobile" maxlength="10" (keypress)="OnlyNumbersAllowed($event)" />
                    </div>
                    <div class="col-md-4">
                        <label class="col-form-label" for="walletId">Wallet ID</label>
                        <input type="text" class="form-control" id="walletId" placeholder="Please enter Wallet ID"
                            [(ngModel)]="walletId" maxlength="50" />

                            <!-- <ng-select id="customerId"  placeholder="Select Customer" [inputAttrs]="{maxlength: '100'}"
                           [(ngModel)]="customerId">
                              <ng-option *ngFor="let customer of customerData" [value]="customer.userId">
                                {{customer.fullName}} ({{customer.userId}})
                              </ng-option>
                            </ng-select> -->
                    </div>
                </div>
        
                <!-- Currency and Amount -->
                <div class="row mt-4">
                  <div class="col-md-4">
                  <label class="col-form-label" for="currency">Currency</label>
                  <!-- <ng-select id="currency" placeholder="Select Currency" [inputAttrs]="{maxlength: '100'}"
                      [(ngModel)]="currency">
                  </ng-select> -->
                  <ng-select id="currency"  placeholder="Select Currency" [inputAttrs]="{maxlength: '100'}"
                  [(ngModel)]="currency">
                     <ng-option *ngFor="let currency of currencyrData" [value]="currency">
                       {{currency}}
                     </ng-option>
                   </ng-select>
                  </div>
                    <!-- <div class="col-md-4">
                        <label class="col-form-label" for="productCode">Product Code</label>
                        <input type="text" class="form-control" id="productCode"
                            [(ngModel)]="productCode" disabled/>
                    </div> -->
                    <div class="col-md-4">
                      <label class="col-form-label" for="txnStatus">Transaction Status</label>
                      <ng-select id="txnStatus" placeholder="Select Transaction Status" [inputAttrs]="{maxlength: '100'}"
                          [(ngModel)]="status" [multiple]="true"  [closeOnSelect]="false">
                          <ng-option value="SUCCESS">Success</ng-option>
                                <ng-option value="FAILED">Failed</ng-option>
                                <ng-option value="PENDING">Pending</ng-option>
                                <ng-option value="REQUEST_INITIATED">Request Initiated</ng-option>
                                <ng-option value="REFUNDED">Refund</ng-option>
                      </ng-select>
                  </div>
                </div>
                                        
        
                <!-- Date Range (From and To) -->
                <div class="row mt-4">
                    <div class="col-md-4">
                        <label class="col-form-label" style="display: block;padding-bottom: 0;">Date From</label>
                        <input #filSearchFromDate [(ngModel)]="searchFromDate"
                        ngbDatepicker #d="ngbDatepicker" class="form-control" id="searchFromDate" placeholder="yyyy-mm-dd"
                        [maxDate]="maxDateFrom" (click)="d.toggle()" (ngModelChange)="changeDate()" />                    </div>
                    <div class="col-md-4">
                        <label class="col-form-label" style="display: block;padding-bottom: 0;">Date To</label>
                        <input #filSearchToDate [(ngModel)]="searchToDate" class="form-control" id="searchToDate"
                        ngbDatepicker #d1="ngbDatepicker"  (click)="d1.toggle()" placeholder="yyyy-mm-dd"
                        [maxDate]="maxDate" [minDate]="minDate" (ngModelChange)="changeEndDate()" />
                    </div>             
                </div>
        
                <!-- Action Buttons -->
                <div class="col-md-12 text-end mt-4">
                    <!-- <button class="btn bg-danger-custom" type="button" (click)="pageNumber=1;">
                        View
                    </button> -->
                </div>
            </div>
            <div class="text-start" >
               
                    <button type="button" class="btn bg-danger-custom" (click)="onSearchFilter()">
                      <i class="feather icon-search me-2"></i>Search
                    </button>
                    <button (click)="resetFilter()" class="btn bg-danger-custom" type="button">Reset</button>

                    <button type="button" class="btn bg-danger-custom" *ngIf="permissions.includes('Search')" (click)="onExportCSV()">
                      <i class="feather icon-download me-2"></i>Export Excel
                    </button>
                    <button type="button" class="btn bg-danger-custom" *ngIf="permissions.includes('Search')" (click)="onBackgroundExport()">
                      <i class="feather icon-download me-2"></i>Export All
                    </button>
                
                        <div class="btn-group" ngbDropdown role="group">
                          <button class="btn bg-danger-custom" ngbDropdownToggle>
                            <i class="feather icon-columns me-2"></i>Columns
                          </button>
                          <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
                            style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
                            <div class="form-group">
                              <!--            <label for="columns" class="form-label"> All Columns</label>-->
                              <div *ngIf="columnDefs" class="list-group ng-option">
                                <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                                  <label class="list-group-item p-2">
                                    <input class="form-check-input me-1" type="checkbox" style="margin-left: 180px;" value="{{i}}" name="{{column.headerName}}"
                                      (change)="updateSelectedColumn($event)"
                                      [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                                    {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') ) }}
                                  </label>
                                </span>
                              </div>
              
                            </div>
              
                          </div>
                        
              
            </div>
            <br>
         
          </div>
        </div>
      </div>
   
      <div *ngIf="quickFilterShow" class="row" style="min-height: 100px">
      
  
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">

                  <label class="col-form-label" for="searchMerName">Search by Legal Name</label>
  
                  <ng-select #filSearchMerName (keyup.enter)="onSearchBtnClick($event)" [(ngModel)]="searchMerName"
                    id="searchMerName" (keyup)="allowAlfanumeric($event)" (keypress)="OnlyCharacterAllowed($event)"
                    (change)="allowAlfanumeric($event)" placeholder="Search by Legal Name"
                    [inputAttrs]="{maxlength: '200'}" (focus)="fun('searchMerName')"
                    (focusout)="funover('searchMerName')">
                    <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.merchant_name">
                      {{merchant.merchant_name}}
                    </ng-option>
                  </ng-select>
  
                </div>
                <div class="col-md-4">
                  <!-- <div class="row"> -->
                  <label class="col-form-label" for="searchMID">Search by Merchant ID</label>
                  <!-- <div class="col-md-8"> -->
  
                  <!-- <input (keyup.enter)="onSearchBtnClick($event)" [(ngModel)]="searchMID" class="form-control"
                  id="searchMID" maxlength="10" (keyup)="allowAlfanumeric($event)" (change)="allowAlfanumeric($event)"
                  type="text" autocomplete="new-password" /> -->
  
                  <ng-select #filSearchMID [(ngModel)]="searchMID" id="searchMID" placeholder="Merchant Id"
                    [inputAttrs]="{maxlength: '100'}" (focus)="fun('searchMID')" (focusout)="funover('searchMID')">
                    <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.MerchantId">
                      {{merchant.merchant_name}} ({{merchant.MerchantId}})
                    </ng-option>
                  </ng-select>
  
  
                  <!-- <ng-select [items]="Resultdata" bindLabel="FieldValue" bindValue="FieldValue" [(ngModel)]="searchMID"
                  id="searchMID" placeholder="Merchant Id">
                  <ng-template ng-option-tmp let-item="item">
                    <div title="{{item.FieldValue}}">{{item.FieldValue}}</div>
                  </ng-template>
                </ng-select> -->
                  <!-- </div> -->
                  <!-- </div> -->
                </div>
  
                <div class="col-md-4">
  
                  <label class="col-form-label" for="resellerPartnerId">Reseller</label>
  
                  <!-- <ng-select [items]="resellerListOptions" bindLabel="FieldText" bindValue="FieldValue"
                  [(ngModel)]="resellerPartnerId" placeholder="Select Reseller Partner" required [inputAttrs]="{maxlength: '100'}">
                </ng-select> -->
                  <ng-select #filResellerPartnerId [(ngModel)]="resellerPartnerId" id="resellerPartnerId"
                    placeholder="Select Reseller Partner" [inputAttrs]="{maxlength: '100'}"
                    (focus)="fun('resellerPartnerId')" (focusout)="funover('resellerPartnerId')">
                    <ng-option *ngFor="let RESELLER of resellerListOptions" [value]="RESELLER.FieldValue">
                      {{RESELLER.FieldText}} ({{RESELLER.FieldValue}})
                    </ng-option>
                  </ng-select>
  
                </div>
              </div>
  
  
              <div class="row">
                <div class="col-md-4">
  
                  <label class="col-form-label" for="resellerPartnerId">Status</label>
  
                  <ng-select #filStatus [items]="merchantStatusdata" bindLabel="FieldText" bindValue="FieldValue"
                    [(ngModel)]="Status" placeholder="Select Status" required [inputAttrs]="{maxlength: '40'}" id="Status"
                    (focus)="fun('Status')" (focusout)="funover('Status')">
                  </ng-select>
  
  
                </div>
  
  
  
                <div class="col-md-4">
                  <div class="row">
                    <label class="col-form-label" for="searchMID">Search by Date Range </label>
                    <div class="col-md-6">
                      <input #filSearchFromDate [(ngModel)]="searchFromDate"
                      ngbDatepicker #d="ngbDatepicker" class="form-control" id="searchFromDate" placeholder="yyyy-mm-dd"
                      [maxDate]="maxDateFrom" (click)="d.toggle()" (ngModelChange)="changeDate()" />
                    </div>
                    <div class="col-md-6">
                      <input #filSearchToDate [(ngModel)]="searchToDate" class="form-control" id="searchToDate"
                      ngbDatepicker #d1="ngbDatepicker"  (click)="d1.toggle()" placeholder="yyyy-mm-dd"
                      [maxDate]="maxDate" [minDate]="minDate" (ngModelChange)="changeEndDate()" />
                    </div>
                  </div>
                </div>
               
  
  
                <div class="mb-3 col-md-2" style="margin-top: 4%;">
                  <!-- <div class="row"> -->
                  <!-- <div class="col-md-12"> -->
                  <!-- <label class="col-form-label" for="searchMID">Search</label> -->
                  <!-- </div>            -->
                  <!-- <div class="col-md-6"> -->
                  <button (click)="onSearchBtnClick($event)" class="btn bg-danger-custom" type="button">
                    <i class="feather icon-search me-2"></i>Search
                  </button>
                  <!-- </div> -->
                  <!-- </div> -->
                </div>
  
              </div>
  
  
            </div>
          </div>
        
      </div>
      <div class="row mb-0" style="min-height: 470px">
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
          <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
            (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
            (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
            (rowDoubleClicked)="onRowDoubleClicked($event)" (search)="globalSearch" [columnDefs]="tableSelectedColumn"
            [defaultColDef]="defaultColDef" [enableCellTextSelection]=true [paginationPageSize]="pageSize"
            [pagination]="true" [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'"
            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
          </ag-grid-angular>
        </div>
      </div>
      <div class="row mt-0">
        <div class="col-4 col-xs-4 d-flex">
          <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
            class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
            <!--          <option [ngValue]="10">10</option>-->
            <!--          <option [ngValue]="20">20</option>-->
            <!--          <option [ngValue]="30">30</option>-->
            <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
          </select>
          <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
        </div>
  
        <div class="col-8 col-xs-8">
          <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
            [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
            [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
          </ngb-pagination>
        </div>
  
      </div>
    </div>
  
  </div>